module.exports = __webpack_public_path__ + "img/logo.3f9c7be6.png";